export default __webpack_public_path__ + "static/media/878.2c4fb127.svg";